import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class StatusFilterService {
    searchIncludesPrivateContacts$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);

    setContactTypeFromSearch(searchIncludesPrivateContacts) {
        this.searchIncludesPrivateContacts$.next(searchIncludesPrivateContacts);
    }

    getContactTypeFromSearch(): Observable<boolean> {
        return this.searchIncludesPrivateContacts$;
    }
}
